import { useEffect, useState } from "react";

export function useLondonTime() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const fmt = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
  const hourFmt = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", hour: "2-digit", hour12: false });
  const time = fmt.format(now);
  const hour = parseInt(hourFmt.format(now), 10);
  const open = hour >= 9 && hour < 18;
  return { time, open };
}

export default function GmtClock({ showStatus = false }) {
  const { time, open } = useLondonTime();
  return (
    <span className="inline-flex items-center gap-2 font-mono text-xs text-slate-400" data-testid="gmt-clock">
      <span className={`h-1.5 w-1.5 rounded-full animate-pulse-dot ${open ? "bg-emerald-400" : "bg-amber-400"}`} />
      LONDON {time} GMT
      {showStatus && <span className={open ? "text-emerald-400" : "text-amber-400"}>{open ? "· OPEN" : "· CLOSED"}</span>}
    </span>
  );
}
